(function(){
'use strict';
var DESIGN=window.Shopify&&Shopify.designMode;
// 1) hide third-party floating widgets (reviews tab, rewards, search bubble, app banners...)
function foreign(el){
  if(el.nodeType!==1)return false;
  var t=el.tagName;
  if(t==='SCRIPT'||t==='STYLE'||t==='LINK'||t==='NOSCRIPT'||t==='TEMPLATE')return false;
  /* the booking form's phone country-code list: on phones intl-tel-input appends it
     to <body> as a fullscreen popup, and this sweeper was executing it on sight —
     which is why the flag dropdown opened invisibly on mobile but worked on desktop */
  if(el.classList&&el.classList.contains('iti'))return false;
  var eid=el.id||'';
  if(/^shopify-block/i.test(eid))return true; // app embeds
  var cls=(el.className&&el.className.baseVal!==undefined)?el.className.baseVal:(el.className||'');
  var id=eid+' '+cls;
  if(/shopify-section|int-|i4|i5|i6|preview|skip|admin|editor|announcement/i.test(id))return false;
  if(el.querySelector&&el.querySelector('[class*="int-"],[class*="i4"],[class*="i5"],[class*="i6"],[id*="shopify-section"]'))return false;
  return true;
}
function sweep(){
  [].forEach.call(document.body.children,function(el){
    if(foreign(el)){el.style.setProperty('display','none','important')}
  });
}
sweep();
new MutationObserver(sweep).observe(document.body,{childList:true});
// 2) count-up stats
var cu=new IntersectionObserver(function(es){es.forEach(function(e){
  if(!e.isIntersecting)return;cu.unobserve(e.target);
  var b=e.target,txt=b.textContent,m=txt.match(/\d+/);if(!m)return;
  var end=+m[0],suffix=b.querySelector('em')?b.querySelector('em').textContent:txt.replace(m[0],''),t0=null;
  function step(ts){t0=t0||ts;var p=Math.min((ts-t0)/1200,1);p=1-Math.pow(1-p,3);
    b.innerHTML=Math.round(end*p)+'<em>'+suffix+'</em>';
    if(p<1)requestAnimationFrame(step)}
  requestAnimationFrame(step);
})},{threshold:.6});
document.querySelectorAll('.int-stat b').forEach(function(b){cu.observe(b)});
// 3) design-mode click-to-place
if(DESIGN){
  document.querySelectorAll('.int-hot, .int-map').forEach(function(box){
    box.addEventListener('click',function(e){
      if(e.target.closest('.int-pin'))return;
      var r=box.getBoundingClientRect();
      var x=Math.round((e.clientX-r.left)/r.width*100),y=Math.round((e.clientY-r.top)/r.height*100);
      var tag=document.createElement('div');tag.className='int-coord';tag.textContent='Position: '+x+','+y+' — copied';
      tag.style.left=x+'%';tag.style.top=y+'%';box.appendChild(tag);
      try{navigator.clipboard.writeText(x+','+y)}catch(err){}
      setTimeout(function(){tag.remove()},2500);
    });
  });
}
})();